import { SolutionDiagnosticsOption, ViewTypeEnum } from "../views/GeneralTask/generalTask.types";

/**
 * Catalog of rupture-set diagnostic plots shown in the rupture-set flip chart.
 *
 * Each `finalPath` is the PNG filename served from
 * `{REPORT_URL}/{fileId}/DiagnosticsReport/resources/{finalPath}` (see RuptureSetImageCard).
 *
 */
export const ruptureSetReportViewOptions: SolutionDiagnosticsOption[] = [
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Log Target Slip Rates",
    finalPath: "slip_rates_log_target.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Rupture Length Histogram",
    finalPath: "hist_LENGTH.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Rupture Magnitude Histogram",
    finalPath: "hist_MAG.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Subsection Count Histogram",
    finalPath: "hist_SECT_COUNT.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Area Histogram",
    finalPath: "hist_AREA.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Max Jump Distance Histogram",
    finalPath: "hist_MAX_JUMP_DIST.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Connected Clusters",
    finalPath: "conn_clusters.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Section Maximum Rupture Length",
    finalPath: "sect_max_LENGTH.png",
    imgHght: 600,
    imgWdth: 500,
  },
  {
    viewType: ViewTypeEnum.Image,
    displayName: "Section Maximum Magnitude",
    finalPath: "sect_max_MAG.png",
    imgHght: 600,
    imgWdth: 500,
  },
];
